import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { API_ENDPOINT } from '../constants';
import { fetchWrapper } from '../helpers';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { SupervisionMetricsItem } from '../utils/types';

const name = 'metrics';
const initialState = createInitialState();
const reducers = createReducers();
// SAFETY: Legacy thunk action creators use the store dispatch result contract.
const extraActions = createExtraActions() as any;
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder: ActionReducerMapBuilder<MetricsState>) => createExtraReducers(builder),
});

export interface MetricsState {
  supervisionMetricsList: Array<SupervisionMetricsItem>;
  error: any;
  loading: boolean;
}

function createInitialState(): MetricsState {
  return {
    supervisionMetricsList: [],
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    clearState,
  };

  function clearState(state: MetricsState) {
    state.supervisionMetricsList = [];
    state.error = null;
    state.loading = false;
  }
}

function createExtraActions() {
  const baseUrl = `${API_ENDPOINT}/metrics`;

  return {
    getSupervisionMetrics: getSupervisionMetrics(),
  };

  function getSupervisionMetrics() {
    return createAsyncThunk(
      `${name}/getSupervisionMetrics`,
      async ({
        getAccessTokenSilently,
        start,
        end,
        clientId,
        exclude_clients_meeting_csn_criteria,
        exclude_zero_session_clients,
      }: any) => {
        let url = `${baseUrl}/duration_aggregates/?start=${start}&end=${end}`;
        if (exclude_zero_session_clients !== undefined) {
          url = url + `&exclude_zero_session_clients=${exclude_zero_session_clients}`;
        }
        if (clientId) {
          url = url + `&client_id=${clientId}`;
        }
        if (exclude_clients_meeting_csn_criteria !== undefined) {
          url =
            url + `&exclude_clients_meeting_csn_criteria=${exclude_clients_meeting_csn_criteria}`;
        }
        const response = await fetchWrapper.get({
          url,
          getAccessTokenSilently,
        });
        return response;
      },
    );
  }
}

function createExtraReducers(builder: ActionReducerMapBuilder<MetricsState>) {
  const { getSupervisionMetrics } = extraActions;

  builder
    // getSupervisionMetrics()
    .addCase(getSupervisionMetrics.pending, (state: MetricsState) => {
      state.loading = true;
      state.error = null;
      state.supervisionMetricsList = [];
    })
    .addCase(
      getSupervisionMetrics.fulfilled,
      (state: MetricsState, action: PayloadAction<SupervisionMetricsItem[]>) => {
        state.supervisionMetricsList = action.payload;
        state.loading = false;
      },
    )
    .addCase(getSupervisionMetrics.rejected, (state: MetricsState, action: any) => {
      state.supervisionMetricsList = [];
      state.error = action.error;
      state.loading = false;
      toast.error(state.error.message);
    });
}

export const metricsActions = { ...slice.actions, ...extraActions };
export const metricsReducer = slice.reducer;
